import React from "react";
import { Paper, Stack, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

/**
 * One titled card in the builder's main column. Every section of the quote looks the same and reads
 * in the same order, so a representative learns the shape of the screen once.
 * @param root0
 * @param root0.title
 * @param root0.children
 * @param root0.sx
 */
export function BuilderSection({
  title,
  action,
  children,
  sx,
}: {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}) {
  return (
    <Paper sx={{ p: 2, ...sx }}>
      <Stack spacing={2} useFlexGap>
        <Stack direction="row" spacing={2} sx={{ alignItems: "baseline" }}>
          <Typography variant="h6" component="h2">
            {title}
          </Typography>
          {action}
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
}
